import { Button, Flex, Icon } from '@inflearn/ds-react';
import { faChevronRight } from '@inflearn/pro-regular-svg-icons';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'next-i18next';

import type { CredentialResponse } from '../../../../../../../resources/@types/accountSchema';
import { INFLEARN_URL } from '../../../../../../constants/urls';
import useClientAccountInventoryQuery from '../../../../../../queries/useClientAccountInventoryQuery';
import { eventNames } from '../../../../../../utils/GTM/eventNames';
import { useTrackMixpanelEvent } from '../../../../../../utils/GTM/useTrackMixpanelEvent';
import { LeaveModal } from './LeaveModal';
import { LeaveSuccessAlertModal } from './LeaveSuccessAlertModal';

export const LeaveServiceSection = ({ accountInfo }: { accountInfo?: CredentialResponse }) => {
  const { t } = useTranslation();

  const [isLeaveModalOpen, { open: openLeaveModalOpen, close: closeLeaveModalOpen }] =
    useDisclosure();
  const [
    isLeaveSuccessAlertModalOpen,
    { open: openLeaveSuccessAlertModal, close: closeLeaveSuccessAlertModal },
  ] = useDisclosure(false);

  const { trackMixpanelEvent } = useTrackMixpanelEvent();

  const {
    data: inventory,
    refetch: refetchInventory,
    isFetching,
  } = useClientAccountInventoryQuery({
    enabled: false,
  });

  const handleClick = async () => {
    trackMixpanelEvent(eventNames.CLICK_DELETE_ACCOUNT);
    await refetchInventory();
    openLeaveModalOpen();
  };

  const handleCloseLeaveSuccessAlertModal = () => {
    closeLeaveSuccessAlertModal();
    window.location.href = INFLEARN_URL.MAIN();
  };

  return (
    <Flex justify="flex-end">
      <LeaveModal
        hasPassword={!!accountInfo?.hasPassword}
        email={accountInfo?.email}
        isOpened={isLeaveModalOpen}
        onClose={closeLeaveModalOpen}
        onSuccess={openLeaveSuccessAlertModal}
        inventory={inventory}
      />
      <LeaveSuccessAlertModal
        opened={isLeaveSuccessAlertModalOpen}
        onClose={handleCloseLeaveSuccessAlertModal}
        onConfirm={handleCloseLeaveSuccessAlertModal}
      />
      <Button
        onClick={handleClick}
        rightIcon={<Icon size="sm" icon={faChevronRight} />}
        variant="subtle"
        color="gray"
        size="sm"
        radius="sm"
        disabled={isFetching}
        loading={isFetching}
      >
        {t('계정 탈퇴')}
      </Button>
    </Flex>
  );
};
